import React from 'react';

class PdfComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      uploadedFiles: []
    };
    this.onLoadEnd = this.onLoadEnd.bind(this);
    this.deletePdf = this.deletePdf.bind(this);
  }

  onLoadEnd(e) {
    const file = e.target.files[0];
    if (!file) return;

    const conf = window.ODOO;
    const upload_url = conf.url + (conf.port ? ':' + conf.port : '') + '/project_upload_pdf';

    const formData = new FormData();
    formData.append('pdfFile', file);

    window.fetch(upload_url, {
      method: 'POST',
      body: formData
    })
    .then(response => response.json())
    .then((data) => {
      if (data) {
        let { parent } = this.props;

        const newIds = data.map((url) => {
          let part = url.split('/content/')[1];
          return parseInt(part.split('?')[0]);
        });

        parent.setState({
          pdf_ids: (parent.state.pdf_ids || []).concat(newIds)
        });

        const newFileObject = {
          id: newIds[0],
          name: file.name
        };

        this.setState({
          uploadedFiles: this.state.uploadedFiles.concat(newFileObject)
        });
      }
    })
    .catch(err => console.error("Błąd przesyłania PDF:", err));
  }

  deletePdf(index, fileId) {
    let { parent } = this.props;

    if (parent.state.pdf_ids) {
      const parentIndex = parent.state.pdf_ids.indexOf(fileId);
      if (parentIndex > -1) {
        parent.state.pdf_ids.splice(parentIndex, 1);
      }
    }

    const updatedLocalFiles = [...this.state.uploadedFiles];
    updatedLocalFiles.splice(index, 1);

    this.setState({
      uploadedFiles: updatedLocalFiles
    });
  }

  render() {
      const { uploadedFiles } = this.state;
      return (
        <div className="images">
          <div className="iu-container" style={{ marginTop: '10px' }}>
            <div className="pdf-flex-container">
              <div className="iu-filesInputContainer">
                <label className="iu-loadContainer">
                  <input
                    type="file"
                    accept=".pdf"
                    onChange={this.onLoadEnd}
                    style={{ display: 'none' }}
                  />
                  <div className="iu-dropzone">
                    <div className="pdf-add-content">
                      <svg
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        className="pdf-add-icon"
                        viewBox="0 0 1000 1000"
                        enableBackground="new 0 0 1000 1000"
                        xmlSpace="preserve"
                      >
                        <g>
                          <path d="M500,10c13.5,0,25.1,4.8,34.7,14.4C544.2,33.9,549,45.5,549,59v392h392c13.5,0,25.1,4.8,34.7,14.4c9.6,9.6,14.4,21.1,14.4,34.7c0,13.5-4.8,25.1-14.4,34.6c-9.6,9.6-21.1,14.4-34.7,14.4H549v392c0,13.5-4.8,25.1-14.4,34.7c-9.6,9.6-21.1,14.4-34.7,14.4c-13.5,0-25.1-4.8-34.7-14.4c-9.6-9.6-14.4-21.1-14.4-34.7V549H59c-13.5,0-25.1-4.8-34.7-14.4C14.8,525.1,10,513.5,10,500c0-13.5,4.8-25.1,14.4-34.7C33.9,455.8,45.5,451,59,451h392V59c0-13.5,4.8-25.1,14.4-34.7C474.9,14.8,486.5,10,500,10L500,10z"></path>
                        </g>
                      </svg>
                    </div>
                  </div>
                </label>
              </div>

              {uploadedFiles.map((file, index) => (
                <div key={index} className="iu-imgPreview" style={{ position: 'relative' }}>
                  <button
                    type="button"
                    className="pdf-delete-btn"
                    onClick={() => this.deletePdf(index, file.id)}
                    title="Usuń plik"
                  >
                    ×
                  </button>
                  <div className="pdf-preview-box">
                    <span style={{ fontSize: '24px', marginBottom: '2px' }}>📄</span>
                    <strong>{file.name.substring(0, 15)}...</strong>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      );
    }
}

export default PdfComponent;